/* InLei® — Leiste am unteren Seitenrand.
   Liegt bewusst als eigene Datei vor: dasselbe Skript direkt in der Section
   fuehrte dazu, dass Shopify die Datei beim GitHub-Sync stillschweigend
   verworfen hat (siehe MEMORY.md). */
(() => {
  const init = (root) => {
    const bar = (root || document).querySelector('[data-inlei-leiste]');
    if (!bar || bar.dataset.inleiReady === 'true') return;
    bar.dataset.inleiReady = 'true';

    const editor = window.Shopify && window.Shopify.designMode;
    const key = bar.dataset.storageKey;
    const threshold = parseInt(bar.dataset.showAfter, 10) || 0;
    let dismissed = false;

    try {
      dismissed = !editor && sessionStorage.getItem(key) === 'zu';
    } catch (e) {
      dismissed = false;
    }
    if (dismissed) return;

    // Im Theme-Editor immer sichtbar, damit der Baustein auswaehlbar bleibt.
    if (editor) {
      bar.classList.add('is-visible');
      return;
    }

    const wurzel = document.documentElement;

    // Sobald der Footer im Bild ist, tritt die Leiste zurueck.
    let footerVisible = false;
    const footer = document.querySelector('.footer, footer');
    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        footerVisible = entries[0].isIntersecting;
        update();
      }, { rootMargin: '0px 0px -40px 0px' }).observe(footer);
    }

    /* Die theme-eigene Fussleiste (<mobile-dock>) faehrt beim Scrollen ein
       und aus und laedt ihr Stylesheet erst nachtraeglich. Eine einmalige
       Messung beim Laden reicht deshalb nicht: Gemessen wird bei jedem
       Update, wie weit der Dock gerade tatsaechlich in den Bildschirm ragt.
       Faehrt er weg oder ist er abgeschaltet, ist der Versatz 0. */
    let dockBeobachtet = false;
    function messen() {
      const dock = document.querySelector('mobile-dock');
      let versatz = 0;
      if (dock && getComputedStyle(dock).display !== 'none') {
        versatz = Math.max(0, Math.round(window.innerHeight - dock.getBoundingClientRect().top));
        if (!dockBeobachtet) {
          dockBeobachtet = true;
          dock.addEventListener('transitionend', messen);
        }
      }
      wurzel.style.setProperty('--leiste-unterkante', versatz + 'px');
      wurzel.style.setProperty('--leiste-hoehe', Math.round(bar.getBoundingClientRect().height) + 12 + 'px');
    }

    /* Chat-Knopf und Leiste teilen sich auf dem Handy den unteren Rand; der
       Knopf ("Brauchst du Hilfe?") lag dabei ueber dem Leisten-Button. Statt
       ihn auszuweichen zu lassen, sind beide nie gleichzeitig zu sehen:
       - Leiste sichtbar  -> <html> traegt .inlei-leiste-an, das CSS blendet
         den geschlossenen Chat aus.
       - Chat geoeffnet   -> das Widget setzt das Attribut "open", die Leiste
         tritt zurueck, bis der Chat wieder zu ist.
       Das Widget wird erst nach dem Seitenaufbau eingefuegt, deshalb wird es
       bei jedem Update gesucht und beim ersten Fund beobachtet. */
    let chat = null;
    function chatOffen() {
      if (!chat) {
        chat = document.querySelector('shopify-chat');
        if (chat) {
          new MutationObserver(update).observe(chat, { attributes: true, attributeFilter: ['open'] });
        }
      }
      return !!(chat && chat.hasAttribute('open'));
    }

    let ticking = false;
    function update() {
      ticking = false;
      messen();
      const show = window.scrollY > threshold && !footerVisible && !chatOffen();
      bar.classList.toggle('is-visible', show);
      // Ausserdem weicht das Google-Bewertungssiegel (maximaler z-index)
      // um die Leistenhoehe nach oben aus.
      wurzel.classList.toggle('inlei-leiste-an', show);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    // Chat und Dock tauchen verzoegert auf — zwei Nachfasser genuegen.
    setTimeout(update, 1500);
    setTimeout(update, 4000);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    const close = bar.querySelector('[data-inlei-leiste-close]');
    if (close) {
      close.addEventListener('click', () => {
        bar.classList.remove('is-visible');
        wurzel.classList.remove('inlei-leiste-an');
        window.removeEventListener('scroll', onScroll);
        try {
          sessionStorage.setItem(key, 'zu');
        } catch (e) {
          /* Privater Modus: dann eben nur fuer diesen Seitenaufruf. */
        }
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  // Der Theme-Editor tauscht die Sektion im laufenden Betrieb aus.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
